import React, { Component } from "react";
import Profile from "./Profile/Profile";
import Marketing from "./Marketing/Marketing";

var pointer = {
  cursor: "pointer"
};

class App extends Component {
  goTo(route) {
    this.props.history.replace(`/${route}`);
  }

  login() {
    this.props.auth.login();
  }

  logout() {
    this.props.auth.logout();
  }

  render() {
    const { isAuthenticated } = this.props.auth;

      return (
        <div>
          {!isAuthenticated() && (
            <div>
              <nav className="navbar navbar-dark bg-dark">
                <a className="navbar-brand" href="/">
                  <img
                    src="https://s3-ap-southeast-2.amazonaws.com/parameterspace.arup.digital/pspace.PNG"
                    alt=""
                    height="42"
                  />
                  parameterspace
                </a>
                <ul className="navbar-nav ml-auto">
                  <li className="navbar-item">
                    <a
                      className="nav-link"
                      style={pointer}
                      onClick={this.login.bind(this)}
                    >
                      Login
                    </a>
                  </li>
                </ul>
              </nav>
              <Marketing />
            </div>
          )}
          {isAuthenticated() && (
            <div>
              <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <a className="navbar-brand" href="/dash">
                  <img
                    src="https://s3-ap-southeast-2.amazonaws.com/parameterspace.arup.digital/pspace.PNG"
                    alt=""
                    height="42"
                  />
                  parameterspace
                </a>
                <ul className="navbar-nav mr-auto">
                  <li className="navbar-item">
                    <a className="nav-link" href="/spaces">
                      View Spaces
                    </a>
                  </li>
                </ul>
                <ul className="navbar-nav ml-auto">
                  <Profile auth={this.props.auth} />
                  <li className="navbar-item">
                    <a
                      className="nav-link"
                      style={pointer}
                      onClick={this.logout.bind(this)}
                    >
                      Logout
                    </a>
                  </li>
                </ul>
              </nav>
              <div className="container">{this.props.children}</div>
            </div>
          )}
        </div>
      );
    } 
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js